<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <!--            <h4 class="card-title mb-4">Edit Role Privileges</h4>-->
            <!-- Supposed Form -->
            <div class="form-body">
              <EditRolePrivilegeForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import EditRolePrivilegeForm from "../../components/Kleyton/Forms/Role/EditRolePrivilegeForm";

export default {
  name: "EditRolePrivilege",
  page: {
    title: "Edit Role Privileges",
    meta: [{ name: "Edit Role Privileges", content: window.__env.app.description }]
  },
  components: {
    EditRolePrivilegeForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "EditRolePrivileges",
      title: "Edit Role Privileges",
      items: [
        {
          text: "Role",
          href: "/"
        },
        {
          text: "Edit Role Privileges",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
